import React from 'react';
import { Questionnaire } from '@/modules/Questionnaire';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import { investorActions } from '@/store/investor';
import { useScrollToTop } from '@/hooks';

export const EditPage = () => {
  const dispatch = useDispatch();
  const investor = useSelector((state) => state.investor);
  const { data } = useQuery({
    queryKey: ['fetchInvestorProfile'],
    queryFn: () => investorActions.fetchInvestorProfile(id, dispatch),
    enabled: !investor.accountStatus
  });

  useScrollToTop([], { behavior: 'auto' });

  const { id, questionnaireId } = useParams();

  return (
    <Questionnaire adminView adminEditView investorId={id} questionnaireId={questionnaireId} />
  );
};
